import {
  apiRoutes,
  getOrderDetailFn,
  type DefaultQueryError,
  type OrderDetail,
  type GetOrderDetailParams,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useGetOrderDetail = (
  orderId: string,
  params?: GetOrderDetailParams,
  opts?: Omit<
    UseQueryOptions<OrderDetail, DefaultQueryError>,
    'queryKey' | 'queryFn'
  >
) =>
  useQuery<OrderDetail, DefaultQueryError>({
    queryKey: [apiRoutes.order.detail(orderId), params],
    queryFn: () => getOrderDetailFn(orderId, params),
    ...opts,
  });
